// Product Subscription Logic - XXXL Size
// Requires: window.SellingPlanMatcher to be loaded first

(function() {
  
  const productConfig = {
    'product-1': {
      variantId: '42447629713443',
      prices: {
        oneTime: { 
          product: '$79.95', 
          total: '$20.00', 
          free: '$79.95' 
        },
        subscription: { 
          product: '$59.96', 
          total: '$39.99', 
          free: '$59.96' 
        }
      }
    },
    'product-2': {
      variantId: '42447629746211',
      prices: {
        oneTime: { 
          product: '$139.90', 
          total: '$60.00', 
          free: '$69.95' 
        },
        subscription: { 
          product: '$104.93', 
          total: '$94.97', 
          free: '$52.46' 
        }
      }
    },
    'product-3': {
      variantId: '42447629778979',
      prices: {
        oneTime: { 
          product: '$239.80', 
          total: '$160.00', 
          free: '$59.95' 
        },
        subscription: { 
          product: '$179.85', 
          total: '$219.95', 
          free: '$44.96' 
        }
      }
    }
  };

  function setupProductRadios(productKey) {
    const config = productConfig[productKey];
    const planData = window.SellingPlanMatcher.getPlanForVariant(config.variantId);
    
    if (!planData) {
      console.warn(`${productKey}: No subscription available`);
    } else {
      console.log(`✅ ${productKey}: Subscription enabled with "${planData.subscriptionPlanName}"`);
    }
    
    $(`.productblock #${productKey} input[type="radio"]`).change(function () {
      if (this.checked) {
        $(`.productblock #${productKey} input[type="radio"]`).not(this).prop('checked', false);
        var val = $(this).val();

        if (val == 1) { 
          // One-time purchase
          $(`.productblock #${productKey} .product-notice`).hide();
          $(`.productblock #${productKey} .delivery`).hide();
          $(`.productblock #${productKey} .product-price`).text(config.prices.oneTime.product);
          $(`.productblock #${productKey} .total-price span`).text(config.prices.oneTime.total);
          $(`.productblock #${productKey} .product-free span`).text(config.prices.oneTime.free);
          
          const url = window.SellingPlanMatcher.buildCartUrl(config.variantId, 1);
          $(`.productblock #${productKey} .btn-cart`).attr('href', url);
          
        } else if (val == 2) { 
          // Subscribe & Save
          $(`.productblock #${productKey} .product-notice`).show();
          $(`.productblock #${productKey} .delivery`).show();
          $(`.productblock #${productKey} .product-price`).text(config.prices.subscription.product);
          $(`.productblock #${productKey} .total-price span`).text(config.prices.subscription.total);
          $(`.productblock #${productKey} .product-free span`).text(config.prices.subscription.free);
          
          const url = window.SellingPlanMatcher.buildCartUrl(
            config.variantId, 
            1, 
            planData ? planData.subscriptionPlanId : null
          );
          $(`.productblock #${productKey} .btn-cart`).attr('href', url);
        }
      }
    });
  }

  $(document).ready(function () {
    setupProductRadios('product-1');
    setupProductRadios('product-2');
    setupProductRadios('product-3');
  });

})();